import { CTA } from '@volkswagen-onehub/components-core';
import { VehicleCardLink } from './VehicleCard';
import { DisabledCTAWrapper } from './VehicleCard.styles';

interface VehicleCardCarNotAvailableProps {
  pdfLink?: VehicleCardLink;
  configuratorLink?: VehicleCardLink;
}

const VehicleCardCarNotAvailable = ({
  pdfLink,
  configuratorLink,
}: VehicleCardCarNotAvailableProps) => (
  <>
    <DisabledCTAWrapper>
      {pdfLink && (
        <CTA tag="a" emphasis="tertiary" href={pdfLink.url}>
          {pdfLink.text}
        </CTA>
      )}

      {configuratorLink && (
        <CTA
          tag="a"
          emphasis="tertiary"
          href={configuratorLink.url}
          target={configuratorLink.target || '_blank'}
        >
          {configuratorLink.text}
        </CTA>
      )}
    </DisabledCTAWrapper>
  </>
);

export default VehicleCardCarNotAvailable;
